var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/* istanbul ignore file */
import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';
import { AuthenticationCheck } from './common/layout/AuthenticationCheck';
var Layout = lazy(function () { return import('./common/layout/Layout'); });
var Routes = lazy(function () { return import('./common/routes/Routes'); });
var App = function () { return (_jsx(BrowserRouter, { children: _jsx(CompatRouter, { children: _jsx(AuthenticationCheck, { children: _jsx(Suspense, __assign({ fallback: "" }, { children: _jsx(Layout, { routes: _jsx(Routes, {}) }) })) }) }) })); };
var container = document.getElementById('root');
var root = createRoot(container); // The "!" operator tells the TS compiler to relax the "not null" constraint
/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * IMPORTANT: DO NOT COMMIT ANY CHANGES TO THIS CONFIGURATION AS IT WILL BREAK TEST/PROD ENVIRONMENTS
 * For more information, refer to this doc: https://quip-amazon.com/p7xrA3aK3JJz/MockServiceWorker
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Only enable the below for local development, when integrating with mock service worker.
 *
 * Ensure to uncomment the MSW configuration on webpack.config.js as well.
 *
 */
// if (process.env.NODE_ENV === 'development') {
//     navigator.serviceWorker
//         .register('/mockServiceWorker.js')
//         .then((registration) => {
//             console.log('Mock service Worker registered:', registration);
//         })
//         .catch((error) => {
//             console.error('Failed to register Mock Service Worker:', error);
//         });
// }
root.render(_jsx(App, {}));
